/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useSimpleConfirmModalStyles = makeStyles({
  modalFooterClass: {
    display: 'flex',
    justifyContent: 'center',
    padding: '0 20px 40px',
    '& > button:first-child': {
      marginRight: '16px',
    },
  },
  modalTitle: {
    padding: '40px 20px',
    textAlign: 'center',
  },
});
